module.exports = __webpack_public_path__ + "img/PPMPRA1.4965d1f8.png";